module.exports = __webpack_public_path__ + "static/img/riseup-icon.3c43115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subscription/riseup-icon.png
// module id = PG1t
// module chunks = 6